export default {
  namespaced: true,
  state: {
    filters: null,
    sorting: null,
    page: null
  },
  mutations: {
    setFilter(state, filter) {
      state.filters = filter
    },
    setSorting(state, sorting) {
      state.sorting = sorting
    },
    setPage(state, page) {
      state.page = page
    }
  },
  getters: {
    full: state => {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/routeQuery.js